/**
 * EmptyState - shared empty state card.
 */
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function EmptyState({ icon: Icon, title, description, ctaLabel, onCta, testid }) {
    return (
        <Card className="p-10 text-center bg-card/40 border-dashed border-white/10 rounded-2xl" data-testid={testid}>
            {Icon && (
                <div className="mx-auto h-12 w-12 rounded-2xl bg-[#6B21D9]/15 grid place-items-center text-[#A78BFA] mb-4">
                    <Icon className="h-6 w-6" />
                </div>
            )}
            <h3 className="font-display font-semibold text-lg">{title}</h3>
            {description && <p className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{description}</p>}
            {ctaLabel && (
                <Button onClick={onCta} className="mt-5 btn-grad-purple text-white" data-testid={`${testid}-cta`}>
                    {ctaLabel}
                </Button>
            )}
        </Card>
    );
}
